import React, { Component } from 'react'
import { TryMap } from '../index'
import './adminRoutes.css';
import '../../css/responsive.css';
class CreateRouteSellers extends Component {

    //#region ######### ONCHANGE FIELDS  ############################################################
    RefreshRouteDocModel = async (RouteDoc) => {
        const { RefreshRouteDocModel } = this.props
        await RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteCode = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Code = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteName = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Name = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeSeller = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.SlpCode = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeComment = (value) => {
        const { RouteDoc } = this.props
        RouteDoc.Comment = value;
        this.RefreshRouteDocModel(RouteDoc);
    }

    ChangeRouteStatus = () => {
        const { RouteDoc } = this.props
        RouteDoc.IsActive = !RouteDoc.IsActive;
        this.RefreshRouteDocModel(RouteDoc);
    }

    //#endregion
    


    render() {
        const { Waypoints, RouteDoc, UnassignedPartners, AddPartnerToRoute, DeleteRoutePartner, SaveRoute, Sellers } = this.props

        return (
            <div className='m-5'>
                <div id="create-Route-form" style={{ marginTop: "2vh" }}>
                    <div class="content-wrapper">
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div className='row'>
                                <div class="col-lg-12 mb-4 order-0">
                                    <div class="card">
                                        <div class="d-flex align-items-end row">
                                            <div class="col-sm-12">
                                                <div class="card-body" >
                                                    <div >
                                                        <TryMap
                                                            waypoints={Waypoints}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div class="col-lg-8 mb-4 order-0">
                                    <div class="card">
                                        <div class="d-flex align-items-end row">
                                            <div class="col-sm-12">
                                                <div class="card-body">
                                                    <h5 class="card-title text-primary">Crear Ruta </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Código de la ruta</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Código"
                                                                value={RouteDoc && RouteDoc.Code ? RouteDoc.Code : ''}
                                                                onChange={(event) => this.ChangeRouteCode(event.target.value)}
                                                            />

                                                        </div>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Nombre de la ruta</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Nombre"
                                                                value={RouteDoc && RouteDoc.Name ? RouteDoc.Name : ''}
                                                                onChange={(event) => this.ChangeRouteName(event.target.value)}
                                                            />

                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-8'>
                                                            <label for="exampleInputEmail1">Vendedor</label>
                                                            <select
                                                                id="toggleCostumer"
                                                                className="form-control"
                                                                value={RouteDoc && RouteDoc.SlpCode ? RouteDoc.SlpCode : ''}
                                                                onChange={(event) => this.ChangeSeller(event.target.value)} >
                                                                <option>Seleccione el vendedor responsable</option>
                                                                
                                                                {Sellers && Sellers.map((seller, index) => {
                                                                    return (
                                                                        <option key={index} value={seller.salesPrson}>
                                                                            {seller.firstName}.- {seller.lastName}. Posición: {seller.name}
                                                                        </option>
                                                                    );
                                                                })}

                                                            </select>
                                                        </div>
                                                        <div className='col-sm-3'>
                                                            {/* <label for="exampleInputEmail1">Buscar por nombre </label>
                                                        <input
                                                            type="email"
                                                            class="form-control"
                                                            id="exampleInputEmail1"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Nombre"
                                                            value={RouteDoc && RouteDoc.name != '' ? RouteDoc.name : ''}
                                                            onChange={(event) => SetData(event.target.value, 2)}
                                                        /> */}
                                                        </div>
                                                        <div className='col-sm-1'>
                                                            {/* <label for="exampleInputEmail1" style={{ color: 'white' }}>.</label>
                                                        <button
                                                            className="btn"
                                                            type="button"
                                                            style={{ backgroundColor: config.palette.primaryColor }}
                                                            // onClick={setCustomerFunction}
                                                        >
                                                            <span class="fa fa-search" style={{ color: 'white' }}></span>
                                                        </button> */}
                                                        </div>

                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-6'>
                                                            <label for="exampleInputEmail1">Comentario</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Comentario"
                                                                value={RouteDoc && RouteDoc.Comment ? RouteDoc.Comment : ''}
                                                                onChange={(event) => this.ChangeComment(event.target.value)}
                                                            />
                                                            {/* <small id="emailHelp" class="form-text text-muted">Cuidado con el nombre que asignes, no podrá ser modificado posteriormente.  </small> */}
                                                        </div>
                                                        <div className='col-sm-1'>
                                                            <div className='d-flex justify-content-center'>
                                                                <label className='' for="exampleInputEmail1">Activa</label>
                                                            </div>
                                                            <div className='d-flex justify-content-center w-100 h-50'>
                                                                <input
                                                                    style={{scale: '2'}}
                                                                    type="checkbox"
                                                                    onChange={() => this.ChangeRouteStatus()}
                                                                    checked={RouteDoc && RouteDoc.IsActive} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h5 class="card-title text-primary mt-2 mb-2">Clientes agregados </h5>
                                                    <div className='row'>
                                                        <div className='col-sm-12'>
                                                            <div class="scrollAddesdBP">
                                                                <ul class="p-0 m-0">
                                                                    {RouteDoc && RouteDoc.RoutesLines.length > 0 &&
                                                                        RouteDoc.RoutesLines.map((docLine, index) => {
                                                                            return (
                                                                                <li class="d-flex mb-4 pb-1">
                                                                                    <div class="avatar flex-shrink-0 me-3" style={{ maxHeight: "25px", maxWidth: "25px" }}>
                                                                                        {/* <img src={"config.resources.userPng"} alt="User" class="rounded" /> */}
                                                                                        <i class="fa fa-user" aria-hidden="true"></i>
                                                                                    </div>
                                                                                    <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                        <div class="me-2">
                                                                                            <small class="text-muted d-block mb-1">{`Latitud: ${docLine.U_FMB_GPSLat}  Longitud: ${docLine.U_FMB_GPSLon}`}</small>
                                                                                            <h6 class="mb-0">{docLine.CardCode}</h6>
                                                                                        </div>
                                                                                        <div class="user-progress d-flex align-items-center gap-1">
                                                                                            <button
                                                                                                className="btn btn-sm"
                                                                                                type="button"
                                                                                                style={{ backgroundColor: "config.navBar.iconBackground", color: "config.navBar.iconModal" }}
                                                                                                onClick={() => DeleteRoutePartner("index")}
                                                                                            >
                                                                                                <button className='btn btn-outline-danger'>
                                                                                                    <i className="fa fa-trash-o"></i>
                                                                                                </button>

                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2 ">

                                                        <div class="col-12 text-right mb-1">
                                                            <button
                                                                type="button"
                                                                class="btn btn-success"
                                                                onClick={() => SaveRoute()}
                                                            >Agregar Ruta</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-4 order-2 mb-4">
                                    <div class="card h-100">
                                        <div class="card-header d-flex align-items-center justify-content-between">
                                            <h5 class="card-title m-0 me-2">Agregar cliente</h5>
                                        </div>
                                        <div class="card-body " >
                                            <div className='scrollCardBP'>
                                                <ul class="p-0 m-0">
                                                    {UnassignedPartners && UnassignedPartners.map((costumer, index) => {
                                                        return (
                                                            <li class="d-flex mb-4 pb-1">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{width: "35px"}}>
                                                                                <div>
                                                                                    {/* <img src={config.resources.userPng} alt="User" class="rounded" /> */}
                                                                                    <i class="fa fa-user" aria-hidden="true"></i>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                                                                    <div class="me-2">
                                                                                        <small class="text-muted d-block mb-1">{costumer.CardName}</small>
                                                                                        <h6 class="mb-0">{costumer.CardCode} </h6>
                                                                                    </div>
                                                                                    <div class="user-progress d-flex align-items-center gap-1 mr-2">
                                                                                        <button
                                                                                            className="btn btn-sm"
                                                                                            type="button"
                                                                                            style={{ backgroundColor: "config.myColors.green", color: "config.navBar.iconModal" }}
                                                                                            onClick={() => AddPartnerToRoute(costumer, index)}
                                                                                        >
                                                                                            <i className="fa fa-plus"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </li>
                                                        );
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content-backdrop fade"></div>
                    </div>

                </div>
            </div>
        )

    }

}

export default CreateRouteSellers